export default "__VITE_ASSET__DmioH$HE__"